<button mat-icon-button (click)="clicked.emit()">
  <mat-icon>{{iconName}}</mat-icon>
</button>
